/* eslint-disable no-console */
import axios from 'axios';

import {CLIMATE_DB_BASE_URL, CLIMATE_DB_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useDataStore from '../../../store/dataStore/dataStore';
import useUserStore from '../../../store/userStore/userStore';
import {ensureAIToken} from '../ClimateDB/aiTokenAPI';

export interface CopilotCitation {
  n: number;
  kind?: string | null;
  label?: string | null;
  link?: string | null;
  source_url?: string | null;
  fy_label?: string | null;
  document_title?: string | null;
}

export interface CopilotChatResponse {
  conversation_id?: string | null;
  answer_markdown?: string | null;
  tool_code?: string | null;
  citations?: CopilotCitation[] | null;
}

/**
 * Asks the Climate DB copilot.
 * `POST /api/chat`, authorised with the Climate DB token.
 * `mongo_company_id` is the signed-in company id, and `user_id` is the signed-in user.
 * The first question goes without `conversation_id`; the id in its answer is
 * kept and sent with every later question so they share one conversation.
 */
const copilotChat = async (
  queryData: string
): Promise<CopilotChatResponse | undefined> => {
  const userId = useUserStore.getState().userDetails._id;
  const companyId = useCompanyStore.getState().companyId;
  const {conversationId, setConversationId} = useDataStore.getState();
  const question = queryData.trim();
  const token = await ensureAIToken();

  if (!token || !companyId || !userId || !question) {
    return undefined;
  }

  try {
    const response = await axios.request<CopilotChatResponse>({
      method: CRUDMethods.POST,
      url: `${CLIMATE_DB_BASE_URL}${CLIMATE_DB_ENDPOINT_JSON.chat}`,
      headers: {Authorization: `Bearer ${token}`},
      timeout: 120000,
      data: {
        mongo_company_id: companyId,
        user_id: userId,
        question,
        ...(conversationId && {conversation_id: conversationId})
      }
    });

    if (!conversationId && response.data?.conversation_id) {
      setConversationId(response.data.conversation_id);
    }

    return response.data;
  } catch (err) {
    console.log('copilot chat err:', err);

    return undefined;
  }
};

export default copilotChat;
